import React, { useEffect, useState } from 'react'
import { shape, string, func, number } from 'prop-types'
import InputField from '../../InputField/InputField'
import Modal from '../../Modal'
import {
  vehicleSections,
  vehicleInputs,
  getFuelTypeOptions
} from '../../../redux/vehicleSelections/constants'
import {
  generateFloatingVehicleLengthLabel,
  renderVehicleError,
  vehicleRequiresFuelType
} from '../../../redux/vehicleSelections/utilities'

const VehicleAdditionalDetails = ({
  formOrder,
  formValues,
  formErrors,
  labels,
  tooltips,
  handleChange,
  openModal,
  modalIsOpen,
  clientContactPhoneNumber,
  route
}) => {
  const [showFuelTypeInfo, setShowFuelTypeInfo] = useState(false)
  const formClass = 'passenger-vehicles__details-form',
    leftLabel = `${labels.vehicleDetails}`,
    licensePlateSubtext = labels.licensePlateInstruction,
    vehicleLengthPlaceholder = `${labels.vehicleLength} (${labels.inFeet})`,
    vehicleLengthSubtext = labels.vehicleLengthHelper,
    showFuelType = vehicleRequiresFuelType(formValues.vehicleType)

  useEffect(() => {
    if (formValues.vehicleType.licensePlateNumberRequired) {
      const licenseInput = document.querySelector(
        `.vehicle-license-plate-number-${route}`
      )
      if (licenseInput) {
        licenseInput.focus()
      }
    }
  }, [
    formValues.vehicleType.licensePlateNumberRequired,
    formValues.vehicleType,
    route
  ])

  return (
    <div
      className="passenger-vehicles__details"
      style={{
        order: formOrder
      }}
    >
      <div className={formClass}>
        {leftLabel && <div className="left-label">{leftLabel}</div>}
        {formValues.vehicleType.licensePlateNumberRequired && (
          <div>
            <InputField
              placeholder={labels.licensePlateNumber}
              type="text"
              dataTest="text-plateNum"
              onChange={e => {
                handleChange(vehicleInputs.LICENSE, e.target.value)
              }}
              useFloatingLabel
              value={formValues.vehicleLicense ? formValues.vehicleLicense : ''}
              inputClassNames={`vehicle-license-plate-number-${route}`}
              error={
                formErrors && formErrors[vehicleInputs.LICENSE]
                  ? renderVehicleError({
                      labels,
                      errorType: formErrors[vehicleInputs.LICENSE]
                    })
                  : false
              }
            />
            {licensePlateSubtext && (
              <div className="passenger-vehicles__details-form-subtext">
                {licensePlateSubtext}
              </div>
            )}
          </div>
        )}
        {formValues.vehicleType.lengthRequired && (
          <div>
            <InputField
              placeholder={vehicleLengthPlaceholder}
              dataTest="text-length"
              onChange={e => {
                const val = e.target.value.replace(/\D/g, '')
                if (!isNaN(val)) {
                  handleChange(vehicleInputs.LENGTH, val)
                }
              }}
              value={
                formValues.vehicleLength
                  ? formValues.vehicleLength.toString()
                  : ''
              }
              inputClassNames="vehicle-lengths"
              parentClassNames={'vehicle-length'}
              error={
                formErrors && formErrors[vehicleInputs.LENGTH]
                  ? renderVehicleError({
                      labels,
                      errorType: formErrors[vehicleInputs.LENGTH],
                      minLength: formValues?.vehicleType?.minLength,
                      maxLength: formValues?.[vehicleSections.LENGTH]?.maxVal,
                      phone: clientContactPhoneNumber
                    })
                  : false
              }
              useFloatingLabel
              floatingLabel={generateFloatingVehicleLengthLabel({
                labels,
                minVal: formValues?.vehicleType?.minLength,
                maxVal: formValues?.[vehicleSections.LENGTH]?.maxVal
              })}
            />
            {tooltips && tooltips['length'] && tooltips['length'] && (
              <div className="passenger-vehicles__details-form-tooltip-container">
                <p className="u-remove-margin">
                  {labels.howToMeasureLengthOfVehicle}
                </p>
                <div
                  onClick={() => {
                    if (
                      !Object.keys(modalIsOpen).includes('vehicle-length-modal')
                    ) {
                      openModal({ type: 'vehicle-length-modal' })
                    }
                  }}
                  className="vehicle-tooltip-trigger-container u-display-flex"
                >
                  <span
                    className="u-tooltip-trigger"
                    data-tooltip="height-tooltip"
                  >
                    ?
                  </span>
                </div>
              </div>
            )}
            {vehicleLengthSubtext && (
              <div className="passenger-vehicles__details-form-subtext">
                {vehicleLengthSubtext}
              </div>
            )}
          </div>
        )}
        {showFuelType && (
          <div className="passenger-vehicles__fuel-type">
            <div className="u-form__field u-form__field-input vehicle-fuel-type">
              <label className="u-form__field-label">
                <select
                  className={`u-form__field-input fuel-type-select ${
                    formValues.vehicleFuelType ? 'has-value' : ''
                  }`}
                  data-test="drop-fuelType"
                  value={formValues.vehicleFuelType || ''}
                  onChange={e => {
                    handleChange(vehicleInputs.FUEL_TYPE, e.target.value)
                  }}
                >
                  <option value="" disabled>
                    {labels.fuelType}
                  </option>
                  {getFuelTypeOptions(labels).map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </label>
              {formErrors && formErrors[vehicleInputs.FUEL_TYPE] && (
                <span className="u-form__field-error">
                  {renderVehicleError({
                    labels,
                    errorType: formErrors[vehicleInputs.FUEL_TYPE]
                  })}
                </span>
              )}
            </div>
            <div className="passenger-vehicles__details-form-subtext passenger-vehicles__fuel-type-subtext">
              <span>
                {labels.vehicleFuelType}
                <button
                  type="button"
                  className="fuel-type-info-trigger"
                  aria-label={labels.alternativeFuelVehicle}
                  aria-expanded={showFuelTypeInfo}
                  data-test="btn-fuelTypeInfo"
                  onClick={() => setShowFuelTypeInfo(true)}
                >
                  <i className="material-icons">info</i>
                </button>
              </span>
            </div>
            <Modal
              isOpen={showFuelTypeInfo}
              onRequestClose={() => setShowFuelTypeInfo(false)}
              className="fuel-type-info-modal"
              contentLabel={labels.alternativeFuelVehicle}
            >
              <div className="fuel-type-info-modal__content">
                <button
                  type="button"
                  className="fuel-type-info-modal__close"
                  aria-label={labels.close || 'Close'}
                  onClick={() => setShowFuelTypeInfo(false)}
                >
                  <i className="material-icons">close</i>
                </button>
                <h4 className="fuel-type-info-modal__title">
                  {labels.alternativeFuelVehicle}
                </h4>
                <div className="fuel-type-info-modal__body">
                  <p>{labels.fuelTypeStatementOne}</p>
                  <p>{labels.fuelTypeStatementTwo}</p>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: labels.fuelTypeStatementThree
                    }}
                  />
                </div>
              </div>
            </Modal>
          </div>
        )}
      </div>
    </div>
  )
}

VehicleAdditionalDetails.propTypes = {
  formOrder: number.isRequired,
  formValues: shape().isRequired,
  formErrors: shape(),
  labels: shape().isRequired,
  tooltips: shape(),
  handleChange: func.isRequired,
  openModal: func.isRequired,
  modalIsOpen: shape().isRequired,
  clientContactPhoneNumber: string,
  route: string
}

export default VehicleAdditionalDetails
